import config from 'react-global-configuration'

const fragment = window.location.search;
const queryParams = fragment.split('?')[1];
const params = new URLSearchParams(queryParams);
const camp = params.get("camp");
const rcid = params.get("rcid");
console.log("camp and rcid", camp, rcid)


const serviceFor = window.location.origin;

config.set({
    ga_tag: "G-6HPV1TM4W4",
    ga_debug: false,
    base: "https://xgames.bngrenew.com/api",
    // elastic_base_url:"http://103.194.44.37:6080/elastic-analytics-service/elastic/publish",
    elastic_base_url:"https://serviceusagesv1.bngrenew.com/publish",
    domain : "btc",
    he : "/he",
    subscribe: '/subscribe',
    requestOTP: "/requestOTP",
    activate: "/activate",
    checkSub: "/checkSub",
    unsubscribe : '/unsubscribe',
    userPacks : '/userPacks',
    appConfig : '/config' , 
    leaderboard:"/getLeaderboard",
    scoreUpdate:"/scoreUpdate",
    headers: {
        // "Buildtype":"demo",
        'Reqfrom': 'web',
        'Username': 'web',
        'Language': 'fr',
        'Servicefor': serviceFor,
    }
})
export const getHeaders = () => {
    const headers = { ...config.get("headers") };  // Get existing headers
    headers["w_req_url"] = window.location.href;
    headers["camp"] = camp || localStorage.getItem("camp") || sessionStorage.getItem("camp") || "";
    headers["rcid"] =rcid || localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || "";
    headers["mtype"] = localStorage.getItem("mtype") || "";
    headers["blocked"] = localStorage.getItem("blocked") || 0;
    headers["breason"] = localStorage.getItem("breason") || "";
    headers["sid"]= localStorage.getItem("sessionId") || "NA";
    return headers;    //return updated headers
};

export default config